export enum ContractTermsType {
  ARRANGE_AGREEMENT = 'ARRANGE_AGREEMENT',
  ARRANGE_PRIVACY = 'ARRANGE_PRIVACY',
  ARRANGE_CALL_PRIVACY = 'ARRANGE_CALL_PRIVACY',
  LINKFARM_AGREEMENT = 'LINKFARM_AGREEMENT',
  LINKFARM_PRIVACY = 'LINKFARM_PRIVACY'
}
